/**
 * URL-safe slug for addressing a task sub-element (service, shell, …) in the
 * path. Stable for a given display name so links round-trip.
 */
export const slug = (value: string): string =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
